import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { clas: "flex flex-column " }
const _hoisted_2 = { class: "w-full my-3 flex flex-column gap-1" }

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Dialog from 'primevue/dialog';
import MultiSelect from 'primevue/multiselect';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddStatesModal',
  setup(__props, { emit: __emit }) {

const relayHubStore = useRelayHubStore();

const { statesAbleToConnect } = storeToRefs(relayHubStore);
const selectedItems = ref<number[]>([]);

const emit = __emit;

const modalVisible = ref(true);

const save = async () => {
  await relayHubStore.addNewStates(selectedItems.value);

  let stateName = 'State';
  if (selectedItems.value.length > 1) stateName = 'States';

  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast(`${stateName} Connected`);

  selectedItems.value = [];
  emit(EMIT.SAVE);
};

const cancel = () => {
  selectedItems.value = [];
  emit(EMIT.CANCEL);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container",
    modal: true,
    draggable: false,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "dialog__header flex flex-column w-8" }, [
        _createElementVNode("h2", { class: "mb-3" }, "Connect States")
      ], -1)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: "Add States",
        disabled: !selectedItems.value.length,
        onClick: save
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "organizations",
            class: "required"
          }, "States", -1)),
          _createVNode(_unref(MultiSelect), {
            id: "organizations",
            modelValue: selectedItems.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event)),
            filter: "",
            class: "w-full",
            options: _unref(statesAbleToConnect),
            "option-label": "name",
            "option-value": "id",
            loading: _unref(relayHubStore).loading,
            placeholder: "Select States to Enable"
          }, null, 8, ["modelValue", "options", "loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})